import React from "react";
import Notifications from "../components/Notifications";

const NotificationsContext = React.createContext({});

const NotificationsProvider = (props) => {
  return (
    <NotificationsContext.Provider value={null}>
      <Notifications />
      {props.children}
    </NotificationsContext.Provider>
  );
};

export { NotificationsProvider, NotificationsContext };
